import { StyledHeaderElement } from '../../../../styles/sharedStyles';
import { StyledEditInputElement } from '../../../../styles/sharedStyles';
import { StyledEditWrapper } from '../../../atoms/SummaryElement/StyledEditWrapper';

const SummaryEditManagerHourEditableTable = ({
    managers,
    managerHourTypes,
    defaultValues,
    values,
}) => {
    return (
        <StyledEditWrapper>
            <StyledHeaderElement $hasWidth={'16.6%'}>
                <StyledEditInputElement $hasDeclaredWidth="100%">
                    <select ref={values.type} defaultValue={defaultValues.type}>
                        {managerHourTypes.map((type) => (
                            <option key={type.id} value={type.id}>
                                {type.name}
                            </option>
                        ))}
                    </select>
                </StyledEditInputElement>
            </StyledHeaderElement>
            <StyledHeaderElement $hasWidth={'16.6%'}>
                <StyledEditInputElement $hasDeclaredWidth="100%">
                    <input type="date" defaultValue={defaultValues.date} ref={values.date} />
                </StyledEditInputElement>
            </StyledHeaderElement>
            <StyledHeaderElement $hasWidth={'16.6%'}>
                <StyledEditInputElement $hasDeclaredWidth="100%">   
                        <input
                            ref={values.hours}
                            id="managerHourHours"
                            type="number"
                            min={0.25}
                            max={99}
                            step={0.25}
                            defaultValue={defaultValues.hours}
                        />

                </StyledEditInputElement>
            </StyledHeaderElement>
            <StyledHeaderElement $hasWidth={'16.6%'}>
                <StyledEditInputElement $hasDeclaredWidth="100%">
                    <select defaultValue={defaultValues.manager} ref={values.manager}>
                        {managers.map((manager) => (
                            <option key={manager.id} value={manager.id}>
                                {manager.lastname} {manager.firstname}
                            </option>
                        ))}
                    </select>
                </StyledEditInputElement>
            </StyledHeaderElement>
            <StyledHeaderElement $hasWidth={'16.6%'}>
                <StyledEditInputElement $hasDeclaredWidth="100%">
                    <input type="text" defaultValue={defaultValues.price} ref={values.price} />
                </StyledEditInputElement>
            </StyledHeaderElement>
            <StyledHeaderElement $hasWidth={'16.6%'}>
                <StyledEditInputElement $hasDeclaredWidth="100%">
                    <input
                        type="text"
                        ref={values.description}
                        defaultValue={defaultValues.description}
                    />
                </StyledEditInputElement>
            </StyledHeaderElement>
        </StyledEditWrapper>
    );
};

export default SummaryEditManagerHourEditableTable;
